export enum ColorType {
    LinearGradient = "linearGradient",
    Radial = "radial",
    Solid = "solid",
}
